import compact from "lodash/compact";
import debounce from "lodash/debounce";
import map from "lodash/map";
import uniqBy from "lodash/uniqBy";
import { IEdge } from "yfiles";
export default (graphReadyRef, onChangeModel, debounceWait) => debounce((sender, evt) => {
    var _a;
    if (!((_a = graphReadyRef.current) === null || _a === void 0 ? void 0 : _a.readyForListeners))
        return;
    if (evt.item instanceof IEdge) {
        const transforms = uniqBy(compact(map(sender.edges.toArray(), "tag")), "Id");
        onChangeModel({ transforms, onlyDiffSources: false });
    }
}, debounceWait);
